module.exports = __webpack_public_path__ + "img/21.4b655244.png";